import "./input-date.css";

interface InputTextProps {
    className?: string;
    error?: string;
    name: string;
    label?: string;
    defaultValue?: any;
    variantError?: boolean;
}

export const InputDate = ({className, error, label, name, defaultValue, variantError}: InputTextProps) => {

    return (
        <div className="input-date-container">
            <p className="input-date-label">{label}</p>
            <input className={`input-date ${className ? className : ""} ${!!error || variantError ? "input-error" : ""}`} name={name} type="date" defaultValue={defaultValue}></input>
            {error && <p className="input-error-message">{error}</p>}
        </div>
    )
};